function PlaySolid({ size }: { size: number }) {
  return (
    <svg height={size} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17.089 10.0794L6 3V21L17.0845 13.8958C17.4072 13.693 17.6732 13.4117 17.8577 13.0782C18.0422 12.7447 18.1392 12.37 18.1397 11.9888C18.1401 11.6077 18.044 11.2327 17.8603 10.8988C17.6765 10.5649 17.4112 10.283 17.089 10.0794V10.0794Z"
        fill="currentColor"
      />
    </svg>
  )
}

export default PlaySolid
